import { DividerLine } from '@/components/atoms'
import { cn } from '@/lib/utils'
import { ChevronLeft } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

type HomeHeaderProps = {
	progress?: string
	className?: string
	showBackButton?: boolean
	/** If provided, the back button navigates here instead of router.back() */
	backHref?: string
}

export function HomeHeader({ progress, className, showBackButton, backHref }: HomeHeaderProps) {
	const router = useRouter()

	return (
		<header className={cn('w-full', className)}>
			<div className="flex items-center justify-between px-5 pt-5">
				<div className="flex items-center gap-2">
					{showBackButton && (
						backHref ? (
							<Link
								href={backHref}
								className="mr-1 flex items-center justify-center p-1 text-black"
							>
								<ChevronLeft className="h-6 w-6 stroke-3" />
							</Link>
						) : (
							<button
								onClick={() => router.back()}
								className="mr-1 flex items-center justify-center p-1 text-black"
							>
								<ChevronLeft className="h-6 w-6 stroke-3" />
							</button>
						)
					)}
					<Link href="/" className="transition-transform active:scale-95">
						<Image
							src="/images/logo-sinko.png"
							alt="SINKO"
							width={90}
							height={20}
							priority
							className="h-auto w-auto"
						/>
					</Link>
				</div>

				{progress && (
					<div className="flex items-center gap-2">
						<TrianglePlayIcon />
						<span className="text-[18px] font-semibold tracking-[0.02em] text-[#202020]">
							{progress}
						</span>
					</div>
				)}
			</div>

			<div className="mt-4">
				<DividerLine />
			</div>
		</header>
	)
}

function TrianglePlayIcon() {
	return (
		<svg
			width="10"
			height="12"
			viewBox="0 0 10 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path d="M1 1L9 6L1 11V1Z" fill="#1565F7" />
		</svg>
	)
}
